import validate from "/app/node_modules/nuxt/dist/pages/runtime/validate.js";
import access_45guard_45global from "/app/middleware/access-guard.global.ts";
import security_45questions_45global from "/app/middleware/security-questions.global.ts";
export const globalMiddleware = [
  validate,
  access_45guard_45global,
  security_45questions_45global
]
export const namedMiddleware = {
  "sanctum:auth": () => import("/app/modules/nuxt-auth-sanctum/runtime/middleware/sanctum.auth.ts"),
  "sanctum:guest": () => import("/app/modules/nuxt-auth-sanctum/runtime/middleware/sanctum.guest.ts")
}